import React, { FC } from "react";
import styles from "./public-info.module.scss";
import SectionTitle from "../../componsnts/common/sectionTitle/sectionTitle";

const PublicInfomation: FC = () => {
    const handleDownload = async (fileName: string, fileType: string) => {
        try {
            const response = await fetch(`/information-file/${fileName}.${fileType}`);
            if (!response.ok) {
                throw new Error("檔案下載失敗");
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${fileName}.${fileType}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to download file:", error);
        }
    };

    const files = [
        // row 1
        [
            { name: '113售電業年報', file: null }, // no file
            { name: '11312簡明月報', file: 'DCP 202412 營運摘要綜合分析報告書' },
            { name: '11401簡明月報', file: 'DCP 202501 營運摘要綜合分析報告書' },
        ],
        // row 2
        [
            { name: '11403簡明月報', file: 'DCP 202503 營運摘要綜合分析報告書' },
            { name: '11404簡明月報', file: 'DCP 202504 營運摘要綜合分析報告書' },
            { name: '11405簡明月報', file: 'DCP 202505 營運摘要綜合分析報告書' },
        ],
        // row 3
        [
            { name: '11406簡明月報', file: 'DCP 202506 營運摘要綜合分析報告書' },
            { name: '11407簡明月報', file: 'DCP 202507 營運摘要綜合分析報告書' },
            { name: '11408簡明月報', file: 'DCP 202508 營運摘要綜合分析報告書' },
        ],
        // row 4
        [
            { name: '11409簡明月報', file: 'DCP 202509 營運摘要綜合分析報告書' },
            { name: '11410簡明月報', file: 'DCP 202510 營運摘要綜合分析報告書' },
            { name: '11411簡明月報', file: 'DCP 202511 營運摘要綜合分析報告書' },
        ],
    ];

    return (
        <div className={styles["publicInfo_container"]}>
            <SectionTitle
                title="公開資訊"
                titleColor="#fff"
                subTitle="INFORMATION"
                subTitleColor="rgba(0, 149, 217, 0.50)"
                backgroundColor="#0077AE"
                breadcrumbs={true}
            />
            <div className="content_box">
                <div className="container" style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
                    {files.map((row, rowIndex) => (
                        <div key={rowIndex} className="file_display_row">
                            {row.map((file, colIndex) => (
                                <div
                                    key={colIndex}
                                    className={`file_box ${!file.file ? 'noFile' : ''}`}
                                    onClick={file.file ? () => handleDownload(file.file, 'pdf') : undefined}
                                >
                                    <div>{file.name}</div>
                                    <img className="pdf_icon" src="/assets/images/public-information/pdf.png" alt="pdf" />
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PublicInfomation;
